import { render, staticRenderFns } from "./Card1.vue?vue&type=template&id=5fd57690&scoped=true&"
import script from "./Card1.vue?vue&type=script&lang=js&"
export * from "./Card1.vue?vue&type=script&lang=js&"
import style0 from "./Card1.vue?vue&type=style&index=0&id=5fd57690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd57690",
  null
  
)

export default component.exports